import { __awaiter } from "tslib";
import a from '@/services/base/config';
import ServicesEnum from '@/services/_helpers/_types';
import { redirectToLogin } from '../_helpers/interceptors';
import SERVICE_CONSTANTS from '@/constants/services';
const request = (service, url, method, data, config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    let baseURL;
    let isTrustService = false;
    const headers = {};
    const params = {};
    switch (service) {
        case (ServicesEnum.traderProfile): {
            baseURL = SERVICE_CONSTANTS.BASE_URL;
            isTrustService = true;
            headers['Cache-Control'] = 'no-store';
            break;
        }
        case (ServicesEnum.passport): {
            baseURL = SERVICE_CONSTANTS.PASSPORT_API;
            isTrustService = true;
            headers['Cache-Control'] = 'no-store';
            params.timestampNoCache = Date.now().toString();
            break;
        }
        case (ServicesEnum.traderProfileV2): {
            baseURL = SERVICE_CONSTANTS.TRADE_V2_API;
            isTrustService = true;
            headers['Cache-Control'] = 'no-store';
            break;
        }
        case (ServicesEnum.screener): {
            baseURL = SERVICE_CONSTANTS.SCREENER;
            break;
        }
        case (ServicesEnum.binancePublic):
            baseURL = SERVICE_CONSTANTS.BINANCE_PUBLIC;
            break;
        case (ServicesEnum.binancePublicFutures):
            baseURL = SERVICE_CONSTANTS.BINANCE_PUBLIC_FUTURES;
            break;
        default: {
            baseURL = SERVICE_CONSTANTS.BASE_URL;
            isTrustService = true;
        }
    }
    const result = {};
    try {
        const binancePublic = service !== ServicesEnum.binancePublic;
        const binancePublicFutures = service !== ServicesEnum.binancePublicFutures;
        const credentials = binancePublic && binancePublicFutures;
        const response = yield a(Object.assign({ baseURL,
            url,
            method,
            data, withCredentials: credentials, headers,
            params }, config));
        result.success = true;
        result.data = response.data;
        result.status = response.status;
    }
    catch (error) {
        if (!error.response && isTrustService) {
            if (error.message !== 'Request aborted' && error.message !== 'Network Error') {
                redirectToLogin();
            }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return yield new Promise(() => { });
        }
        result.success = false;
        if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
            result.data = error.response.data;
        }
        else {
            result.data = {};
        }
        result.status = (_b = error.response) === null || _b === void 0 ? void 0 : _b.status;
        return result;
    }
    return result;
});
export default request;
